export default sentence =>
  sentence
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");



// WEBPACK FOOTER //
// ./utils/capitalizeSentence.js